module.exports = __webpack_public_path__ + "static/media/menu_icon_02.b6a9ad7f.svg";